import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, userPreferencesFeatureKey } from './user-preferences.reducer';

export const getUserPreferencesFeature = createFeatureSelector<State>(userPreferencesFeatureKey);

export const getUserPreferences = createSelector(getUserPreferencesFeature, (state) => {
   return state.userPreferences;
});

export const getExpandMenuUserPreference = createSelector(getUserPreferences, (userPreferences): boolean | null => {
   return userPreferences?.ExpandMenu ?? null;
});

export const getSelectedDashboardUserPreference = createSelector(
   getUserPreferences,
   (userPreferences): number | null => {
      return userPreferences?.SelectedDashboardId ?? null;
   }
);

export const getMostRecentDeviceTypeUserPreference = createSelector(
   getUserPreferences,
   (userPreferences): string | null => {
      return userPreferences?.MostRecentDeviceType ?? null;
   }
);

export const getUseAlternatingRowColors = createSelector(getUserPreferences, (userPreferences): boolean | null => {
   return userPreferences?.UseAlternatingRowColors ?? null;
});

export const getShowExtensionRegisterPopupUserPreference = createSelector(
   getUserPreferences,
   (userPreferences): boolean | null => {
      return userPreferences?.ShowExtensionRegisterPopup ?? null;
   }
);

export const getQueueHistoryRegisterWrapQueuesUserPreference = createSelector(
   getUserPreferences,
   (userPreferences): boolean | null => {
      return userPreferences?.QueueHistoryRegisterWrapQueues ?? null;
   }
);

export const getExpandCallDetailAdvancedSectionUserPreference = createSelector(
   getUserPreferences,
   (userPreferences): boolean | null => {
      return userPreferences?.ExpandCallDetailAdvancedSection ?? null;
   }
);
